import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUnitedairlinesComponent } from './simple-icons-unitedairlines.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUnitedairlinesComponent ],
    exports:      [ SimpleIconsUnitedairlinesComponent ],
    bootstrap:    []
})
export class SimpleIconsUnitedairlinesModule {}
